"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadUserChallengeRanking = function loadUserChallengeRanking(payload) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CHALLENGE_RANKING',
    payload: payload
  };
};

var loadUserChallengeRankingSuccess = function loadUserChallengeRankingSuccess(userChallengeRanking) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CHALLENGE_RANKING_SUCCESS',
    payload: {
      userChallengeRanking: userChallengeRanking
    }
  };
};

var loadUserChallengeRankingError = function loadUserChallengeRankingError(userChallengeRankingError) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CHALLENGE_RANKING_ERROR',
    payload: {
      userChallengeRankingError: userChallengeRankingError
    }
  };
};

var resetUserChallengeRanking = function resetUserChallengeRanking() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_USER_CHALLENGE_RANKING'
  };
};

var loadRanking = function loadRanking(payload) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_RANKING',
    payload: payload
  };
};

var loadRankingSuccess = function loadRankingSuccess(ranking) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_RANKING_SUCCESS',
    payload: {
      ranking: ranking
    }
  };
};

var loadRankingError = function loadRankingError(rankingError) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_RANKING_ERROR',
    payload: {
      rankingError: rankingError
    }
  };
};

var resetRanking = function resetRanking() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_RANKING'
  };
};

var updateRankingFilters = function updateRankingFilters(filters) {
  return {
    type: 'OLY_ENGINE_STORE_UPDATE_RANKING_FILTERS',
    payload: _objectSpread({}, filters)
  };
};

var resetRankingFilters = function resetRankingFilters() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_RANKING_FILTERS'
  };
};

var loadChallengeRanking = function loadChallengeRanking(payload) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_CHALLENGE_RANKING',
    payload: payload
  };
};

var loadChallengeRankingSuccess = function loadChallengeRankingSuccess(challengeRanking) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_CHALLENGE_RANKING_SUCCESS',
    payload: {
      challengeRanking: challengeRanking
    }
  };
};

var loadChallengeRankingError = function loadChallengeRankingError(challengeRankingError) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_CHALLENGE_RANKING_ERROR',
    payload: {
      challengeRankingError: challengeRankingError
    }
  };
};

var resetChallengeRanking = function resetChallengeRanking() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_CHALLENGE_RANKING'
  };
};

var updateChallengeRankingFilters = function updateChallengeRankingFilters(filters) {
  return {
    type: 'OLY_ENGINE_STORE_UPDATE_CHALLENGE_RANKING_FILTERS',
    payload: _objectSpread({}, filters)
  };
};

var resetChallengeRankingFilters = function resetChallengeRankingFilters() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_CHALLENGE_RANKING_FILTERS'
  };
};

var _default = {
  loadRanking: loadRanking,
  loadRankingSuccess: loadRankingSuccess,
  loadRankingError: loadRankingError,
  resetRanking: resetRanking,
  updateRankingFilters: updateRankingFilters,
  resetRankingFilters: resetRankingFilters,
  loadChallengeRanking: loadChallengeRanking,
  loadChallengeRankingSuccess: loadChallengeRankingSuccess,
  loadChallengeRankingError: loadChallengeRankingError,
  resetChallengeRanking: resetChallengeRanking,
  loadUserChallengeRanking: loadUserChallengeRanking,
  loadUserChallengeRankingSuccess: loadUserChallengeRankingSuccess,
  loadUserChallengeRankingError: loadUserChallengeRankingError,
  resetUserChallengeRanking: resetUserChallengeRanking,
  updateChallengeRankingFilters: updateChallengeRankingFilters,
  resetChallengeRankingFilters: resetChallengeRankingFilters
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map